var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark"},[_c('img',{attrs:{"src":_vm.publicPath+'/media'+_vm.mediaURL+_vm.logoURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }